import { IsOptional, IsString, MaxLength } from 'class-validator';

export class MessageSearchDTO {

    @IsString()
    @MaxLength(50)
    title: string;

}
